export interface ConfigData {
  locale?: string;
  api?: string;
  projectId?: string;
  organizationId?: string;
  timezone?: string;
  requestId?: string;
}

/** What a pull of project data needs from the config; an entity may need less (`requiredConfig`). */
export const PROJECT_PULL_CONFIG_KEYS: readonly (keyof ConfigData)[] = ['locale', 'api', 'projectId'];

export interface GetDocumentationSignedRequestEventDetail {
  documentationId: string;
  versionId: string;
  token: string;
}
